<template>
    <div class="parnter">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="请输入公司名称" :search-submit="$_getTableList">
                </mc-search-bar>
            </template>
            <template slot="right">
                <el-button type="primary" @click="dialog.site.methods.open()">新增</el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label"
                    :width="tableOption.head[0].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label"
                    :width="tableOption.head[1].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label"
                    :width="tableOption.head[2].width" v-if="tableOption.head.length>0">
                </el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label"
                    :width="tableOption.head[3].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label"
                    :width="tableOption.head[4].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label"
                    :width="tableOption.head[5].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item key"
                            @click="dialog.key.methods.open(scope.row)">{{scope.row.address}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[6].prop" :label="tableOption.head[6].label"
                    :width="tableOption.head[6].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[7].prop" :label="tableOption.head[7].label"
                    :width="tableOption.head[7].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" :disabled="scope.row.ban == 1"
                            @click="dialog.site.methods.open(scope.row)">修改</el-button>
                        <el-button size="mini" type="default" :disabled="scope.row.ban == 1"
                            @click="dialog.reset.methods.open(scope.row)">重置</el-button>
                        <el-button v-if="!scope.row.ban||scope.row.ban == 0" size="mini" type="warning"
                            @click="dialog.freeze.methods.open(scope.row)">冻结</el-button>
                        <el-button v-if="scope.row.ban == 1" size="mini" type="warning"
                            @click="dialog.unfreeze.methods.open(scope.row)">解冻</el-button>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="parnter-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.key">
            <template slot="content">
                <span>{{this.dialog.key.data.key}}</span>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.unfreeze">
            <template slot="content">
                <mc-label icon="el-icon-warning" warn>确定要解冻该合作伙伴吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.freeze">
            <template slot="content">
                <mc-label icon="el-icon-warning" warn>确定要冻结该合作伙伴吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.reset">
            <template slot="content">
                <mc-label icon="el-icon-warning" warn>确定重置该合作伙伴密码吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.site">
            <template slot="content">
                <mc-layout-row label-text="账号" :label-width="150" important>
                     <el-input placeholder="请选择" v-model="dialog.site.data.site.login_username"></el-input>
                    <!-- <el-input placeholder="请选择" v-if="JSON.stringify(dialog.site.data.row) == '{}'"
                        v-model="dialog.site.data.site.login_username"></el-input> -->
                    <!-- <mc-label info v-else>{{dialog.site.data.site.login_username}}</mc-label> -->
                </mc-layout-row>
                <mc-layout-row label-text="公司名称" :labelWidth="150" important>
                    <!-- <el-input placeholder="请选择" v-if="JSON.stringify(dialog.site.data.row) == '{}'" v-model="dialog.site.data.site.partner_name"></el-input> -->
                    <el-input placeholder="请选择" v-model="dialog.site.data.site.partner_name"></el-input>
                    <!-- <mc-label info v-else>{{dialog.site.data.site.partner_name}}</mc-label> -->
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="150" important>
                    <el-select style="width:100%" placeholder="请选择" v-model="dialog.site.data.province"
                        @change="$_getCitysList">
                        <el-option v-for="item in provinceSelect" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="150" important>
                    <el-select style="width:100%" placeholder="请选择" v-model="dialog.site.data.city"
                        @change="$_getDistrictsList">
                        <el-option v-for="item in citySelect" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="区/县" :labelWidth="150" important>
                    <el-select style="width:100%" placeholder="请选择" v-model="dialog.site.data.district"
                        @change="$_selectRegion">
                        <el-option v-for="item in districtsSelect" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="邮箱" :labelWidth="150" important>
                    <el-input style="width:100%" placeholder="请选择" v-model="dialog.site.data.site.email"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="联系方式" :labelWidth="150" important>
                    <el-input style="width:100%" placeholder="请选择" v-model="dialog.site.data.site.mobile"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="详细地址" :labelWidth="150" important>
                    <el-input style="width:100%" placeholder="请选择" v-model="dialog.site.data.site.address"></el-input>
                </mc-layout-row>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: "sparnter",
        data() {
            return {
                searchParmas: '',
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                provinceList: [],
                provinceSelect: [],
                cityList: [],
                citySelect: [],
                districtsList: [],
                districtsSelect: [],
                fileList: [],
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: false,
                        label: "操作",
                        items: [{
                                label: "修改",
                                type: "primary",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.site.methods.open(row);
                                }
                            },
                            {
                                label: "重置",
                                type: "default",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.reset.methods.open(row);
                                }
                            }
                        ]
                    },
                    head: [{
                            prop: "partner_name",
                            label: "公司名称",
                            width: "",
                        },
                        {
                            prop: "login_username",
                            label: "登陆账号",
                            width: "",
                        },
                        {
                            prop: "province",
                            label: "省份",
                            width: "70",
                        },
                        {
                            prop: "city",
                            label: "市",
                            width: "70",
                        },
                        {
                            prop: "district",
                            label: "区/县",
                            width: "70",
                        },
                        {
                            prop: "address",
                            label: "地址",
                            width: "",
                        },
                        {
                            prop: "site_count",
                            label: "站点数量",
                            width: "80",
                        },
                        {
                            prop: "",
                            label: "操作",
                            width: "220",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    key: {
                        visible: false,
                        title: "用户详情",
                        style: {
                            showConfirm: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.key.visible = true;
                                this.dialog.key.data.key = item.address;
                            },
                        },
                        data: {
                            key: "",
                        },
                    },
                    site: {
                        visible: false,
                        title: "修改合作伙伴",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                this.$_resetDate();
                                this.dialog.site.data.row = item;
                                if (this.dialog.site.data.row === undefined) {
                                    this.dialog.site.data.row = {}
                                }
                                this.dialog.site.visible = true;
                                if (item) {
                                    this.dialog.site.data.site.address = item.address;
                                    this.dialog.site.data.site.email = item.email;
                                    this.dialog.site.data.site.mobile = item.mobile;
                                    this.dialog.site.data.site.login_username = item.login_username;
                                    this.dialog.site.data.site.partner_name = item.partner_name;
                                    this.dialog.site.data.city = item.city;
                                    this.dialog.site.data.city_code = item.city_code;
                                    this.dialog.site.data.province = item.province;
                                    this.dialog.site.data.province_code = item.province_code;
                                    this.dialog.site.data.district = item.district;
                                    this.dialog.site.data.id = item.id;
                                    this.dialog.site.data.district_code = item.district_code;
                                    this.$_getCitysList(this.dialog.site.data.province_code)
                                    this.$_getDistrictsList(this.dialog.site.data.city_code)
                                    this.dialog.site.title = "修改合作伙伴"
                                } else {
                                    this.dialog.site.title = "新建合作伙伴"
                                }
                            },
                            confirm: () => {
                                if (JSON.stringify(this.dialog.site.data.row) == '{}') {
                                    this.$_newSite();
                                } else {
                                    this.$_editorSite(this.dialog.site.data.row);
                                }
                            }
                        },
                        data: {
                            row: {},
                            site: {
                                partner_name: '',
                                login_username: '',
                                address: '',
                                license: '',
                                region: '',
                                email: '',
                                mobile: ''
                            },
                            id: '',
                            city: '',
                            city_code: '',
                            province: '',
                            province_code: '',
                            district: '',
                            district_code: '',
                        },
                    },
                    reset: {
                        visible: false,
                        title: "重置密码",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.reset.data.row = item
                                this.dialog.reset.visible = true;
                            },
                            confirm: () => {
                                this.$_resetKey(this.dialog.reset.data.row.id)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    freeze: {
                        visible: false,
                        title: "冻结合作伙伴",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.freeze.data.row = item
                                this.dialog.freeze.visible = true;
                            },
                            confirm: () => {
                                this.$_freezePartner(this.dialog.freeze.data.row)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    unfreeze: {
                        visible: false,
                        title: "解冻合作伙伴",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.unfreeze.data.row = item
                                this.dialog.unfreeze.visible = true;
                            },
                            confirm: () => {
                                this.$_freezePartner(this.dialog.unfreeze.data.row)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                },
            }
        },
        mounted() {
            this.$_getProvinceList();
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params;
                if (this.searchParmas == "") {
                    params = {
                        page: this.pager.page,
                        per_page: this.pager.per_page
                    }
                } else {
                    params = {
                        partner_name: this.searchParmas,
                        page: this.pager.page,
                        per_page: this.pager.per_page
                    }
                }
                let data = await this.$api.oneKeeperPartner.getList.getTable.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getProvinceList: async function () {
                let params = {}
                let data = await this.$api.adminSiteManaging.getList.getProvinces.call(this, params);
                if (data !== false) {
                    this.provinceList = data;
                    this.$_handleProvinceList();
                }
            },
            $_getCitysList: async function (item) {
                this.cityList = [];
                this.citySelect = [];
                let params = {
                    province: item
                }
                let data = await this.$api.adminSiteManaging.getList.getCity.call(this, params);
                if (data !== false) {
                    this.cityList = data;
                    this.$_handleCityList();
                }
            },
            $_getDistrictsList: async function (item) {
                this.districtsList = [];
                this.districtsSelect = [];
                let params = {
                    city: item
                }
                let data = await this.$api.adminSiteManaging.getList.getDistricts.call(this, params);
                if (data !== false) {
                    this.districtsList = data;
                    this.$_handleDistrictsListList();
                }
            },
            $_newSite: async function (item) {
                if (!this.$_checkSite()) {
                    return
                }
                let params = {
                    address: this.dialog.site.data.site.address,
                    region: this.dialog.site.data.district,
                    partner_name: this.dialog.site.data.site.partner_name,
                    login_username: this.dialog.site.data.site.login_username,
                    email: this.dialog.site.data.site.email,
                    mobile: this.dialog.site.data.site.mobile,
                }
                let data = await this.$api.oneKeeperPartner.do.creatPartner.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("创建成功.");
                }
                this.dialog.site.visible = false;
            },
            $_editorSite: async function (item) {
                if (!this.$_checkSite()) {
                    return
                }
                let params = {
                    login_username: this.dialog.site.data.site.login_username,
                    partner_name: this.dialog.site.data.site.partner_name,
                    address: this.dialog.site.data.site.address,
                    region: this.dialog.site.data.district_code,
                    email: this.dialog.site.data.site.email,
                    mobile: this.dialog.site.data.site.mobile,
                    id: item.id
                }
                let data = await this.$api.oneKeeperPartner.do.editorPartner.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("修改成功.");
                }
                this.dialog.site.visible = false;
            },
            $_checkSite() {
                let reg = new RegExp(/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/);
                let tel_reg = new RegExp(/^1([38]\d|5[0-35-9]|7[3678])\d{8}$/)
                if (this.dialog.site.data.site.login_username == '') {
                    this.$message.warning("请填写登陆账号.");
                    return false
                }
                // if (reg.test(this.dialog.site.data.site.login_username) == false) {
                //     this.$message.warning("登陆账号格式错误，请填写邮件格式.");
                //     return false
                // }
                if (this.dialog.site.data.site.partner_name == '') {
                    this.$message.warning("请填写公司名称.");
                    return false
                }
                if (this.dialog.site.data.district == '') {
                    this.$message.warning("请填写公司所在区域.");
                    return false
                }
                if (this.dialog.site.data.site.address == '') {
                    this.$message.warning("请填写详细地址.");
                    return false
                }
                if (this.dialog.site.data.site.email == '') {
                    this.$message.warning("请填写邮箱.");
                    return false
                }
                if (reg.test(this.dialog.site.data.site.email) == false) {
                    this.$message.warning("邮箱格式错误，请填写正确的格式.");
                    return false
                }
                if (this.dialog.site.data.site.mobile == '') {
                    this.$message.warning("请填写手机号码.");
                    return false
                }
                if (tel_reg.test(this.dialog.site.data.site.mobile) == false) {
                    this.$message.warning("手机号码格式错误，请填写正确的手机号码.");
                    return false
                }
                return true
            },
            $_resetKey: async function (item) {
                let params = {
                    id: item,
                }
                let data = await this.$api.oneKeeperPartner.do.resetPartner.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("重置成功.");
                }
                this.dialog.reset.visible = false;
            },
            $_freezePartner: async function (item) {
                let banType = ""
                if (item.ban == 0 || !item.ban) {
                    banType = 1
                } else {
                    banType = 0
                }
                let params = {
                    id: item.id,
                    ban: banType
                }
                let data = await this.$api.oneKeeperPartner.do.freezePartner.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    if (item.ban == 1) {
                        this.dialog.unfreeze.visible = false;
                        this.$message.success("解冻成功.");
                    } else {
                        this.dialog.freeze.visible = false;
                        this.$message.success("冻结成功.");
                    }
                }
                this.dialog.reset.visible = false;
            },
            $_selectRegion(item) {
                this.dialog.site.data.site.region = item
            },
            $_handleProvinceList() {
                for (let i = 0; i < this.provinceList.length; i++) {
                    let obj = {
                        value: this.provinceList[i].province_code,
                        label: this.provinceList[i].province
                    };
                    this.provinceSelect.push(obj)
                }
            },
            $_handleCityList() {
                for (let i = 0; i < this.cityList.length; i++) {
                    let obj = {
                        value: this.cityList[i].city_code,
                        label: this.cityList[i].city
                    };
                    this.citySelect.push(obj)
                }
            },
            $_handleDistrictsListList() {
                for (let i = 0; i < this.districtsList.length; i++) {
                    let obj = {
                        value: this.districtsList[i].district_code,
                        label: this.districtsList[i].district
                    };
                    this.districtsSelect.push(obj)
                }
            },
            $_handlerDialogData(data1, data2) {
                for (let i in data1) {
                    if (data2[i] !== undefined) {
                        data1[i] = data2[i];
                    } else {
                        data1[i] = null;
                    }
                }
                return data1;
            },
            $_resetDate() {
                this.dialog.site.data.site.address = '';
                this.dialog.site.data.site.login_username = '';
                this.dialog.site.data.site.partner_name = '';
                this.dialog.site.data.site.region = '';
                this.dialog.site.data.city = '';
                this.dialog.site.data.row = {};
                this.dialog.site.data.id = '';
                this.dialog.site.data.province = '';
                this.dialog.site.data.district = '';
                this.dialog.site.data.city_code = '';
                this.dialog.site.data.province_code = '';
                this.dialog.site.data.district_code = '';
                this.dialog.site.data.site.mobile = '';
                this.dialog.site.data.site.email = '';
                this.cityList = [];
                this.citySelect = [];
                this.districtsList = [];
                this.districtsSelect = [];
            },
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .parnter {
        width: 100%;

        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .key {
            min-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .el-dialog {
            .require {
                color: red
            }

            .site-item {
                display: inline-flex;
                align-items: center;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 100px;
                    text-align: right;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;
                }
            }
        }
    }
</style>